
// Common InsightCard interface to be used throughout the app
export interface InsightCard {
  id: string;
  title: string;
  category: string;
  category_id?: string; // New field for DB category reference
  agreePercentage: number;
  totalPollsters: number;
  description: string;
  insights?: string[];
  country_code?: string | null;
  constituency_code?: string | null;
  status: 'draft' | 'published' | 'archived'; // Changed from optional to required
  created_at?: string;
  updated_at?: string;
  linked_poll?: string | null;
  stats_status?: string | null; // Changed from specific literals to string | null
  slug?: string | null;
}

// Helper function to transform database card to frontend format
export const transformDatabaseCard = (dbCard: any): InsightCard => {
  // Check if slug is an object with _type and value properties (happens when undefined is serialized)
  const slug = dbCard.slug && typeof dbCard.slug === 'object' && dbCard.slug._type === 'undefined' 
    ? null 
    : dbCard.slug;
    
  return {
    id: dbCard.id,
    title: dbCard.title,
    category: dbCard.category,
    category_id: dbCard.category_id,
    agreePercentage: dbCard.agree_percentage,
    totalPollsters: dbCard.total_pollsters,
    description: dbCard.description,
    country_code: dbCard.country_code,
    constituency_code: dbCard.constituency_code,
    status: dbCard.status as 'draft' | 'published' | 'archived',
    created_at: dbCard.created_at,
    updated_at: dbCard.updated_at,
    insights: dbCard.card_insights?.map((insight: any) => insight.insight_text) || [],
    linked_poll: dbCard.linked_poll,
    stats_status: dbCard.stats_status,
    slug: slug
  };
};

// Helper function to transform frontend card to database format
export const transformCardForDatabase = (card: InsightCard) => {
  // Ensure all required fields are present and have correct types
  // Make sure we create a new object with only the fields needed for the database
  // and with properly named fields to avoid ambiguous column references
  return {
    id: card.id,
    title: card.title?.trim() || '',
    category: card.category?.trim() || '',
    category_id: card.category_id || null,
    agree_percentage: typeof card.agreePercentage === 'number' ? card.agreePercentage : 50,
    total_pollsters: typeof card.totalPollsters === 'number' ? card.totalPollsters : 0,
    description: card.description?.trim() || '',
    country_code: card.country_code || null,
    constituency_code: card.constituency_code === 'all_constituencies' ? null : card.constituency_code,
    status: card.status || 'draft',
    linked_poll: card.linked_poll,
    stats_status: card.stats_status,
    slug: card.slug
  };
};

